import { ServiceClient } from 'src/utils'
import { CondicaoRow } from '../regra.types'

const serviceClient = ServiceClient.singleton()

export class CondicaoService {
    static #INSTANCE = new CondicaoService()
    static readonly singleton = () => CondicaoService.#INSTANCE

    async fetchCondicaoInfo(idAnalise: number, idRegra: number, id: number) {
        return serviceClient.authGet<CondicaoRow>(`/api/v1/analise/${idAnalise}/regra/${idRegra}/condicao/${id}`)
    }

    async updateCondicao(idAnalise: number, idRegra: number, id: number, condicao: CondicaoRow) {
        const response = await serviceClient.authPut<CondicaoRow>(
            `/api/v1/analise/${idAnalise}/regra/${idRegra}/condicao/${id}`,
            condicao
        )
        return response
    }

    async saveCondicao(idAnalise: number, idRegra: number, condicao: CondicaoRow) {
        const response = await serviceClient.authPost<CondicaoRow>(
            `/api/v1/analise/${idAnalise}/regra/${idRegra}/condicao`,
            condicao
        )
        return response
    }

    async deleteCondicao(idAnalise: number, idRegra: number, id: number) {
        const response = await serviceClient.authDelete(`/api/v1/analise/${idAnalise}/regra/${idRegra}/condicao/${id}`)
        return response
    }
}

export default CondicaoService.singleton()
